/**
 * Detects if the navigator is iOS Safari
 */
function detect() {
    const devices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ];

    const re = new RegExp(`${ devices.join('|') }`);

    if (re.test(navigator.userAgent) && !window.MSStream) {
        document.documentElement.className += ' ios';
        return true;
    }

    return false;
}


export const isIos = detect();



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/util/fixes/ios-detect/index.js